import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Checkbox,
  ListItemText,
  OutlinedInput,
  Box,
  Tooltip,
  Grid,
  Chip,
  Typography,
  Autocomplete,
  TextField,
} from "@mui/material";
import "./Analytics.css";

export default function MultiSelectFilter({
  label,
  value,
  options,
  onChange,
  isMultiple,
  onMetaChange,
}) {
  const getOptionValue = (item) => {
    if (typeof item === "string") return item;
    if (typeof item === "object" && item !== null)
      return item?.origin_port ?? "";
    return "";
  };

  const getOptionLabel = (item) => {
    if (typeof item === "string") return item;
    if (typeof item === "object" && item !== null) {
      const port = item.origin_port ?? "";
      const country = item.origin_country ?? "";
      if (port && country) return `${port} (${country})`;
      if (port) return port;
      if (country) return country;
      return "";
    }
    return "";
  };

  const getLabel = (item) => {
    if (typeof item === "string") return item;
    if (!item || typeof item !== "object") return "";
    if (item.origin_port && item.origin_country) {
      return `${item.origin_port} (${item.origin_country})`;
    } else if (item?.name && item?.id) {
      return `${item?.name}`;
    }
    const firstValue = Object.values(item).find(
      (v) => typeof v === "string" || typeof v === "number"
    );
    return firstValue ? String(firstValue) : "";
  };

  return (
    <>
      <Grid item xs={12} lg={6} sx={{ minWidth: 0 }}>
        <Box className="label_name">
          {/* <img src={originCountryImg} alt="img" /> */}
          &nbsp;
          {/* <Tooltip
            title="Use this drop down to filter the required origin country in the table below."
            placement="right"
          >
          </Tooltip> */}
          <span className="label-style">{label}</span>
        </Box>
        <FormControl fullWidth size="small">
          {isMultiple ? (
            /* 🔹 MULTI SELECT (Checkbox) */
            <Select
              multiple
              fullWidth
              labelId="demo-multiple-checkbox-label"
              id="demo-multiple-checkbox"
              // value={value}
              value={isMultiple ? value : value || ""}
              onChange={(e) => {
                const selectedValues = e.target.value; // string[]
                onChange(selectedValues);
                const selectedObjects = options.filter((item) => {
                  return selectedValues.includes(getOptionValue(item));
                });
                const payloadData = selectedObjects.map((item) => ({
                  origin_country: item.origin_country,
                  origin_port: item.origin_port,
                }));
                if (typeof onMetaChange === "function") {
                  onMetaChange(payloadData);
                }
              }}
              sx={{
                minWidth: 0, // 🔑 flex/grid fix
                "& .MuiSelect-select": {
                  display: "block", // 🔑 stop inline-flex growth
                  width: "100%",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  fontSize: 13,
                  fontWeight: 600,
                  text: "bold",
                },
              }}
              renderValue={(selected) => (
                <Typography
                  sx={{
                    fontSize: 13,
                    fontWeight: 600,
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    width: "100%",
                    display: "block",
                  }}
                >
                  {selected.join(", ")}
                </Typography>
              )}
            >
              {Array.isArray(options) &&
                options.map((item, index) => {
                  const optionValue = getOptionValue(item);
                  const optionLabel = getOptionLabel(item);
                  return (
                    <MenuItem
                      key={`${optionValue}-${index}`}
                      value={optionValue}
                      sx={{
                        minHeight: 36, // ⬅️ same as Autocomplete
                        py: 0.0, // vertical padding
                        px: 1.5, // horizontal padding
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                        fontSize: 13,
                        fontWeight: 400,
                      }}
                    >
                      <Checkbox checked={value?.includes(optionValue)} />
                      <ListItemText
                        primary={optionLabel}
                        // primaryTypographyProps={{ noWrap: true }}
                        primaryTypographyProps={{
                          noWrap: true,
                          fontSize: 13,
                          fontWeight: 400,
                          lineHeight: "20px",
                        }}
                        sx={{
                          m: 0,
                        }}
                      />
                    </MenuItem>
                  );
                })}
            </Select>
          ) : (
            <Autocomplete
              options={options || []}
              value={value || null}
              onChange={(_, newValue) => {
                if (label === "Tariff") {
                  onChange(newValue?.id);
                } else {
                  onChange(newValue);
                }
              }}
              // ✅ ALWAYS string for UI
              getOptionLabel={getLabel}
              // ✅ Prevents MUI mismatch warnings
              isOptionEqualToValue={(option, value) =>
                getLabel(option) === getLabel(value)
              }
              sx={{
                minWidth: 0, // 🔑 flex/grid fix
                "& .MuiInputBase-input": {
                  color: "#0f172a", // 👈 selected text color
                  fontSize: 13,
                  fontWeight: 600,
                },
              }}
              // ✅ Safe dropdown rendering
              renderOption={(props, option) => (
                <li {...props} key={getLabel(option)}>
                  {getLabel(option)}
                </li>
              )}
              renderInput={(params) => (
                <TextField {...params} size="small" placeholder="Search..." />
              )}
            />
          )}
        </FormControl>
      </Grid>
    </>
  );
}
